import Vue from 'vue';

import Modal from '../components/global/Modal.vue';
import OptionalLink from '../components/global/OptionalLink.vue';
import CircleButton from '../components/global/CircleButton.vue';
import Page from '../components/global/Page.vue';
import Collapse from '../components/global/Collapse.vue';
import ToggleArrow from '../components/global/ToggleArrow.vue';
import AnimatedNumber from '../components/global/AnimatedNumber.vue';
import TearLine from '../components/global/TearLine.vue';
import Icon from '../components/global/Icon.vue';
import ArrowLeft from '../components/global/ArrowLeft.vue';
import ArrowRight from '../components/global/ArrowRight.vue';
import Loader from '../components/global/Loader.vue';

Vue.component('modal', Modal);
Vue.component('optional-link', OptionalLink);
Vue.component('loader', Loader);
Vue.component('circle-button', CircleButton);
Vue.component('page', Page);
Vue.component('toggle-arrow', ToggleArrow);
Vue.component('collapse', Collapse);
Vue.component('animated-number', AnimatedNumber);
Vue.component('tear-line', TearLine);
Vue.component('icon', Icon);
Vue.component('arrow-left', ArrowLeft);
Vue.component('arrow-right', ArrowRight);
